import { LINK_TYPE, ANCHOR_TYPE, CUSTOM_LINK_TYPE } from './types.js';

const linkEntityStrategy = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    if (entityKey !== null) {
      const entityType = contentState.getEntity(entityKey).getType();
      return entityType === LINK_TYPE || entityType === ANCHOR_TYPE || entityType === CUSTOM_LINK_TYPE;
    }
    return false;
  }, callback);
};

export { linkEntityStrategy };
//# sourceMappingURL=strategy.js.map
